import React from 'react';
import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function.js";
import {DocumentAmountField} from "./DocumentAmount.component";
import {CostCentersDetails} from "./CostCentersDetails.component";
import {Tooltip} from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

const PurchaseOrderDocumentDetailsDTO = ({details, translate}) => {
    let displayId = details.displayId ? details.displayId : details.documentId;

    return (
        <div>
            {details.description &&
            <div className="document-data-field">
                <div className="document-data-field-label">
                    {translate("documentData.description")}
                </div>
                <div className="document-data-field-value"
                     data-tip="description-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                    {details.description}
                    <Tooltip id="description-value-tooltip" content={() => details.description}/>
                </div>
            </div>}

            <div className="document-data-divided">
                {details.claimant &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.requester")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="claimant-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {details.claimant}
                        <Tooltip id="claimant-value-tooltip" content={() => details.claimant}/>
                    </div>
                </div>}

                {details.costRequestDate &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.expenseDate")}
                    </div>
                    <div className="document-data-field-value">
                        {formatDate(details.costRequestDate)}
                    </div>
                </div>}

                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.documentID")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="documentID-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {displayId}
                        <Tooltip id="documentID-value-tooltip" content={() => displayId}/>
                    </div>
                </div>

                {details.supplierName &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.supplierName")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="supplierName-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {details.supplierName}
                        <Tooltip id="supplierName-value-tooltip" content={() => details.supplierName}/>
                    </div>
                </div>}

                {details.supplierNumber &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.supplierNumber")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="supplierNumber-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {details.supplierNumber}
                        <Tooltip id="supplierNumber-value-tooltip" content={() => details.supplierNumber}/>
                    </div>
                </div>}

                <DocumentAmountField details={details} translate={translate}/>

                {details.employeeCode &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.employeeCode")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="employeeCode-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {details.employeeCode}
                        <Tooltip id="employeeCode-value-tooltip" content={() => details.employeeCode}/>
                    </div>
                </div>}

                {details.documentOrganizationUnit &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.organizationUnit")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="organizationUnit-value-tooltip" data-for={SHARED_TOOLTIP_ID}>
                        {formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                        <Tooltip id="organizationUnit-value-tooltip" content={() => formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>
                    </div>
                </div>}

                {details.documentCostUnitList && details.documentCostUnitList.length > 0 &&
                <CostCentersDetails costUnitList={details.documentCostUnitList}
                                    translate={translate}/>}
            </div>
        </div>
    )
};

export default PurchaseOrderDocumentDetailsDTO;
